export function isSameId(firstId, secondId) {
    if (!firstId || !secondId) {
        return false;
    }
    return firstId == secondId;
}
export function byId(data, id) {
    return data.find(el => isSameId(el.id, id));
}
export function includesId(data, id) {
    return !!data?.find(el => isSameId(el, id));
}
export function getVisibleCards(state) {
    return Object.keys(state.cardsMap).reduce((acc, key) => {
        return acc.concat(state.cardsMap[key]);
    }, []);
}
export function getAreaId(columnId, rowId) {
    return `${columnId}` + (rowId ? `:${rowId}` : "");
}
export function getCardAreaId(card, columnKey, rowKey) {
    if (rowKey) {
        return card[columnKey] + ":" + card[rowKey];
    }
    else {
        return card[columnKey];
    }
}
export function checkScroll(e, el, config = { shift: 20 }) {
    let scrollTimer = null;
    function scroll() {
        if (el) {
            const contentRect = el.getBoundingClientRect();
            const scrollState = {
                x: el.scrollLeft,
                y: el.scrollTop,
            };
            const { shift } = config;
            if (e.clientX > contentRect.width + contentRect.left - shift) {
                el.scrollTo(scrollState.x + shift, scrollState.y);
            }
            if (e.clientX < contentRect.left + shift) {
                el.scrollTo(scrollState.x - shift, scrollState.y);
            }
            if (e.clientY > contentRect.height + contentRect.top - shift) {
                el.scrollTo(scrollState.x, scrollState.y + shift);
            }
            if (e.clientY < contentRect.top + shift) {
                el.scrollTo(scrollState.x, scrollState.y - shift);
            }
            scrollTimer = setTimeout(() => {
                scroll();
            }, 100);
        }
    }
    scroll();
    return () => {
        if (scrollTimer) {
            clearTimeout(scrollTimer);
        }
    };
}
export function normalizeMenuConfig(config) {
    var _a;
    const { shape, defaultMenuItems, store } = config;
    const nShape = shape || {};
    if (nShape.menu === false) {
        return {
            menu: {
                show: false,
                items: () => null,
            },
        };
    }
    nShape.menu || (nShape.menu = {});
    if (Array.isArray(nShape.menu.items)) {
        const items = [...nShape.menu.items];
        nShape.menu.items = () => items;
    }
    const menuItemsFn = nShape.menu.items || defaultMenuItems;
    nShape.menu.items = (config) => menuItemsFn({ ...config, store });
    (_a = nShape.menu).show ?? (_a.show = true);
    return nShape;
}
//# sourceMappingURL=helpers.js.map